import { useState, useEffect } from 'react';
import { styled, useTheme, Box, Button, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

export function Page(props) {
    const theme = useTheme();

    let maxWidth = theme.breakpoints.values.lg;

    if (props.width) {
        maxWidth = theme.breakpoints.values[props.width];
    }

    return (
        <Box ml="auto" mr="auto" maxWidth={maxWidth}>
            <Box p={[2, 4]} pb={[14]}>
                {props.children}
            </Box>
        </Box>
    );
}

export function AdminPage(props) {
    return (
        <Box px={[2, 4]} pt={3} pb={3} height="100%">
            {props.children}
        </Box>
    );
}

export function ScrollRestoreContainer(props) {
    const [ready, setReady] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            setReady(true);
        }, 50);
    }, []);

    if (ready === false) {
        return null;
    }

    return props.children;
}

export const ControlBar = styled('div')(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(3),
}));

export const ControlBarHeader = (props) => {
    const variant = props.size === 'small' ? 'h5' : 'h4';

    if (typeof props.expanded === 'boolean') {
        return (
            <Box
                display={'flex'}
                alignItems={'center'}
                onClick={() => props.toggleExpanded(!props.expanded)}
                sx={{
                    '&:hover': {
                        cursor: 'pointer',
                    },
                }}
            >
                <Typography variant={variant} textTransform="none" fontWeight="bold">
                    {props.children}
                </Typography>
                {props.expanded === true && <ExpandLessIcon />}
                {props.expanded === false && <ExpandMoreIcon />}
            </Box>
        );
    }
    return (
        <Typography variant={variant} fontWeight={'bold'} marginRight={'auto'}>
            {props.children}
        </Typography>
    );
};

export const ControlBarButton = styled(Button)(({ theme }) => ({
    marginLeft: theme.spacing(2),
}));
ControlBarButton.defaultProps = { color: 'secondary', variant: 'contained' };
